import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { AnimateComponent } from '@app/components/animate/animate.component';

@Component({
  selector: 'app-blik-section',
  templateUrl: './blik-section.component.html',
  styleUrls: ['./blik-section.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage, AnimateComponent],
})
export class BlikSectionComponent {}
